import moment from "moment/moment";

export function getInitialPeriod(subtrDay = 0) {
  return {
    from: moment().add(-1 * subtrDay, "d").set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toISOString(),
    to: moment().set('hour', 23).set('minute', 59).set('second', 0).set('millisecond', 0).toISOString(),
  };
}
